import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskLineInView } from "../motion/Reveal";
import { IMAGES } from "../../data/content";

export const Success = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);

  return (
    <section id="success" className="relative py-24 md:py-36 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(60% 50% at 50% 20%, rgba(197,160,89,0.08), transparent 70%)" }}
      />
      <div className="container-editorial relative z-10">
        <div className="text-center max-w-5xl mx-auto">
          <p className="overline mb-8">07 — A Different Definition of Success</p>
          <h2 className="font-serif text-3xl md:text-6xl leading-[1.12] tracking-tight text-bone">
            <MaskLineInView>Success is not a single destination.</MaskLineInView>
            <MaskLineInView delay={0.08}>It is the ability to make better</MaskLineInView>
            <MaskLineInView delay={0.16}>
              decisions, remain <span className="italic text-gold">grounded</span> through
            </MaskLineInView>
            <MaskLineInView delay={0.24}>uncertainty, grow through failure, and</MaskLineInView>
            <MaskLineInView delay={0.32}>build a life aligned with meaningful values.</MaskLineInView>
          </h2>
        </div>

        {/* Full image — natural color, no crop */}
        <Reveal y={50} delay={0.15}>
          <motion.div
            ref={ref}
            style={{ y }}
            className="relative mt-14 md:mt-20 overflow-hidden border border-white/10 bg-ink"
          >
            <img
              src={IMAGES.successImage}
              alt="Dakka Gabriel Rey"
              className="w-full h-auto object-contain"
              loading="lazy"
            />
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};
